import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '@/store/index'

const selectAuthState = (state: RootState) => state.auth

export const selectAuthStatus = createSelector(
  selectAuthState,
  (auth) => auth.status,
)

export const selectSession = createSelector(
  selectAuthState,
  (auth) => auth.session,
)

export const selectIsAuthenticated = createSelector(
  selectAuthStatus,
  (status) => status === 'authenticated',
)

export const selectLoginFields = createSelector(
  selectAuthState,
  (auth) => auth.fields,
)

export const selectLoginError = createSelector(
  selectAuthState,
  (auth) => auth.loginError,
)

export const selectIsSubmitting = createSelector(
  selectAuthState,
  (auth) => auth.isSubmitting,
)

export const selectSessionDisplayName = createSelector(
  selectSession,
  (session) => session?.displayName ?? 'Superadmin',
)

export const selectSessionEmail = createSelector(
  selectSession,
  (session) => session?.email ?? '',
)
